// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sobre-nosotros {
  background-color: #f9f9f9;
  padding: 80px 0;
}

.sobre-nosotros .section-title {
  color: #5B4B8A;
  text-align: center;
  margin-bottom: 60px;
  font-size: 2.5rem;
  letter-spacing: 0.5px;
}

/* Sección de Testimonios */
.testimonios-container {
  margin-bottom: 80px;
  padding-bottom: 60px;
  border-bottom: 2px solid #e0e0e0;
}

.testimonios-container .subsection-title {
  color: #5B4B8A;
  text-align: center;
  font-size: 10.8rem;
  margin-bottom: 10px;
  letter-spacing: 0.3px;
}

.subsection-subtitle {
  text-align: center;
  color: #555;
  margin-bottom: 40px;
  font-size: 1.4rem;
}

.testimonios-video-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  margin: 0 auto;
  max-width: 760px;
}

.testimonio-video-frame {
  position: relative;
  width: min(78vw, 440px);
  aspect-ratio: 1 / 1;
  border: 4px solid #FF8C00;
  border-radius: 14px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.testimonio-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.testimonio-play,
.testimonio-pause {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: none;
  cursor: pointer;
  z-index: 2;
  font-weight: 700;
}

.testimonio-play {
  padding: 14px 22px;
  border-radius: 999px;
  background: rgba(255, 140, 0, 0.9);
  color: #fff;
  font-size: 1rem;
  letter-spacing: 0.4px;
  min-width: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-icon {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 16px solid #ffffff;
  margin-left: 3px;
}

.testimonio-pause {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(91, 75, 138, 0.85);
  color: #fff;
  font-size: 1.1rem;
}

.testimonios-nav {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background: #5B4B8A;
  color: #fff;
  font-size: 1.35rem;
  font-weight: 700;
  box-shadow: 0 6px 16px rgba(91, 75, 138, 0.35);
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.testimonios-nav:hover {
  transform: translateY(-2px);
  background: #6a58a2;
}

.testimonio-frase {
  max-width: 760px;
  margin: 18px auto 0;
  padding: 16px 20px;
  background: #ffffff;
  border-left: 4px solid #FF8C00;
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  color: #4c4c4c;
  font-size: 1.02rem;
  line-height: 1.6;
  font-style: italic;
  text-align: center;
}

.testimonios-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.testimonio-card {
  background: white;
  border-left: 5px solid #FF8C00;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.testimonio-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.testimonio-contenido {
  display: flex;
  flex-direction: column;
}

.testimonio-texto {
  font-style: italic;
  font-size: 1.05em;
  color: #555;
  margin-bottom: 20px;
  line-height: 1.6;
}

.testimonio-autor {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.autor-nombre {
  font-family: 'Playfair Display', serif;
  font-weight: bold;
  color: #333;
  font-size: 1.1em;
  letter-spacing: 0.3px;
}

.autor-cargo {
  color: #FF8C00;
  font-size: 0.95em;
  font-weight: 500;
}

.autor-empresa {
  color: #888;
  font-size: 0.9em;
}

.testimonios-vacio {
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 1.1em;
  font-style: italic;
  background: white;
  border-radius: 8px;
  border-left: 5px solid #e0e0e0;
}

/* Sección del Equipo */
.equipo-container {
  padding-top: 40px;
}

.equipo-container .subsection-title {
  color: #5B4B8A;
  text-align: center;
  font-size: 1.8rem;
  margin-bottom: 40px;
  letter-spacing: 0.3px;
}

.grid-3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
}

.equipo-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  padding: 30px;
  text-align: center;
}

.equipo-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.equipo-foto {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 auto 20px;
  display: block;
  border: 4px solid #FF8C00;
}

.equipo-foto-2 {
  object-position: 0 -28px;
}

.equipo-foto-3 {
  object-position: 0 -4px;
}

.equipo-card h4 {
  font-family: 'Playfair Display', serif;
  color: #5B4B8A;
  font-size: 1.4em;
  margin-bottom: 8px;
  letter-spacing: 0.3px;
}

.equipo-rol {
  color: #FF8C00;
  font-weight: 500;
  font-size: 0.95em;
  margin-bottom: 12px;
}

.equipo-descripcion {
  color: #555;
  font-size: 0.95em;
  margin-bottom: 20px;
  line-height: 1.5;
  height: 95px;
}

.equipo-especialidades {
  text-align: left;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #f0f0f0;
}

.equipo-especialidades h5 {
  color: #5B4B8A;
  font-size: 0.95em;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
}

.equipo-especialidades ul {
  list-style: none;
  padding: 0;
}

.equipo-especialidades li {
  color: #666;
  font-size: 0.9em;
  margin-bottom: 8px;
  line-height: 1.4;
  padding-left: 15px;
  position: relative;
}

.equipo-especialidades li:before {
  content: '';
  width: 6px;
  height: 6px;
  background-color: #FF8C00;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0.35em;
}

/* Responsive */
@media (max-width: 768px) {
  .sobre-nosotros {
    padding: 50px 0;
  }

  .sobre-nosotros .section-title {
    font-size: 2rem;
    margin-bottom: 40px;
  }

  .testimonios-container {
    margin-bottom: 50px;
    padding-bottom: 40px;
  }

  .testimonios-container .subsection-title {
    font-size: 1.5rem;
  }

  .subsection-subtitle {
    font-size: 1.05rem;
    margin-bottom: 22px;
  }

  .testimonios-video-wrapper {
    gap: 10px;
  }

  .testimonio-video-frame {
    width: min(74vw, 330px);
    border-width: 3px;
  }

  .testimonios-nav {
    width: 38px;
    height: 38px;
    font-size: 1.1rem;
  }

  .testimonio-play {
    padding: 10px 16px;
    font-size: 0.9rem;
  }

  .testimonio-frase {
    margin-top: 14px;
    padding: 12px 14px;
    font-size: 0.95rem;
  }

  .grid-3 {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .equipo-foto {
    width: 120px;
    height: 120px;
  }

  .equipo-card h4 {
    font-size: 1.2em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SobreNosotros.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,2DAA2D;AAC7D;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qDAAqD;EACrD,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".sobre-nosotros {\r\n  background-color: #f9f9f9;\r\n  padding: 80px 0;\r\n}\r\n\r\n.sobre-nosotros .section-title {\r\n  color: #5B4B8A;\r\n  text-align: center;\r\n  margin-bottom: 60px;\r\n  font-size: 2.5rem;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n/* Sección de Testimonios */\r\n.testimonios-container {\r\n  margin-bottom: 80px;\r\n  padding-bottom: 60px;\r\n  border-bottom: 2px solid #e0e0e0;\r\n}\r\n\r\n.testimonios-container .subsection-title {\r\n  color: #5B4B8A;\r\n  text-align: center;\r\n  font-size: 10.8rem;\r\n  margin-bottom: 10px;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.subsection-subtitle {\r\n  text-align: center;\r\n  color: #555;\r\n  margin-bottom: 40px;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.testimonios-video-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 18px;\r\n  margin: 0 auto;\r\n  max-width: 760px;\r\n}\r\n\r\n.testimonio-video-frame {\r\n  position: relative;\r\n  width: min(78vw, 440px);\r\n  aspect-ratio: 1 / 1;\r\n  border: 4px solid #FF8C00;\r\n  border-radius: 14px;\r\n  overflow: hidden;\r\n  background: #000;\r\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.testimonio-video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.testimonio-play,\r\n.testimonio-pause {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  border: none;\r\n  cursor: pointer;\r\n  z-index: 2;\r\n  font-weight: 700;\r\n}\r\n\r\n.testimonio-play {\r\n  padding: 14px 22px;\r\n  border-radius: 999px;\r\n  background: rgba(255, 140, 0, 0.9);\r\n  color: #fff;\r\n  font-size: 1rem;\r\n  letter-spacing: 0.4px;\r\n  min-width: 64px;\r\n  min-height: 64px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.play-icon {\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 10px solid transparent;\r\n  border-bottom: 10px solid transparent;\r\n  border-left: 16px solid #ffffff;\r\n  margin-left: 3px;\r\n}\r\n\r\n.testimonio-pause {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  background: rgba(91, 75, 138, 0.85);\r\n  color: #fff;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.testimonios-nav {\r\n  width: 44px;\r\n  height: 44px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  background: #5B4B8A;\r\n  color: #fff;\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  box-shadow: 0 6px 16px rgba(91, 75, 138, 0.35);\r\n  transition: transform 0.2s ease, background-color 0.2s ease;\r\n}\r\n\r\n.testimonios-nav:hover {\r\n  transform: translateY(-2px);\r\n  background: #6a58a2;\r\n}\r\n\r\n.testimonio-frase {\r\n  max-width: 760px;\r\n  margin: 18px auto 0;\r\n  padding: 16px 20px;\r\n  background: #ffffff;\r\n  border-left: 4px solid #FF8C00;\r\n  border-radius: 10px;\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\r\n  color: #4c4c4c;\r\n  font-size: 1.02rem;\r\n  line-height: 1.6;\r\n  font-style: italic;\r\n  text-align: center;\r\n}\r\n\r\n.testimonios-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 30px;\r\n  margin-top: 40px;\r\n}\r\n\r\n.testimonio-card {\r\n  background: white;\r\n  border-left: 5px solid #FF8C00;\r\n  padding: 25px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.testimonio-card:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.testimonio-contenido {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.testimonio-texto {\r\n  font-style: italic;\r\n  font-size: 1.05em;\r\n  color: #555;\r\n  margin-bottom: 20px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.testimonio-autor {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.autor-nombre {\r\n  font-family: 'Playfair Display', serif;\r\n  font-weight: bold;\r\n  color: #333;\r\n  font-size: 1.1em;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.autor-cargo {\r\n  color: #FF8C00;\r\n  font-size: 0.95em;\r\n  font-weight: 500;\r\n}\r\n\r\n.autor-empresa {\r\n  color: #888;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.testimonios-vacio {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  color: #999;\r\n  font-size: 1.1em;\r\n  font-style: italic;\r\n  background: white;\r\n  border-radius: 8px;\r\n  border-left: 5px solid #e0e0e0;\r\n}\r\n\r\n/* Sección del Equipo */\r\n.equipo-container {\r\n  padding-top: 40px;\r\n}\r\n\r\n.equipo-container .subsection-title {\r\n  color: #5B4B8A;\r\n  text-align: center;\r\n  font-size: 1.8rem;\r\n  margin-bottom: 40px;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.grid-3 {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 40px;\r\n}\r\n\r\n.equipo-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  padding: 30px;\r\n  text-align: center;\r\n}\r\n\r\n.equipo-card:hover {\r\n  transform: translateY(-8px);\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.equipo-foto {\r\n  width: 150px;\r\n  height: 150px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  margin: 0 auto 20px;\r\n  display: block;\r\n  border: 4px solid #FF8C00;\r\n}\r\n\r\n.equipo-foto-2 {\r\n  object-position: 0 -28px;\r\n}\r\n\r\n.equipo-foto-3 {\r\n  object-position: 0 -4px;\r\n}\r\n\r\n.equipo-card h4 {\r\n  font-family: 'Playfair Display', serif;\r\n  color: #5B4B8A;\r\n  font-size: 1.4em;\r\n  margin-bottom: 8px;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.equipo-rol {\r\n  color: #FF8C00;\r\n  font-weight: 500;\r\n  font-size: 0.95em;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.equipo-descripcion {\r\n  color: #555;\r\n  font-size: 0.95em;\r\n  margin-bottom: 20px;\r\n  line-height: 1.5;\r\n  height: 95px;\r\n}\r\n\r\n.equipo-especialidades {\r\n  text-align: left;\r\n  margin-top: 20px;\r\n  padding-top: 20px;\r\n  border-top: 2px solid #f0f0f0;\r\n}\r\n\r\n.equipo-especialidades h5 {\r\n  color: #5B4B8A;\r\n  font-size: 0.95em;\r\n  font-weight: 600;\r\n  margin-bottom: 12px;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.equipo-especialidades ul {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.equipo-especialidades li {\r\n  color: #666;\r\n  font-size: 0.9em;\r\n  margin-bottom: 8px;\r\n  line-height: 1.4;\r\n  padding-left: 15px;\r\n  position: relative;\r\n}\r\n\r\n.equipo-especialidades li:before {\r\n  content: '';\r\n  width: 6px;\r\n  height: 6px;\r\n  background-color: #FF8C00;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0.35em;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .sobre-nosotros {\r\n    padding: 50px 0;\r\n  }\r\n\r\n  .sobre-nosotros .section-title {\r\n    font-size: 2rem;\r\n    margin-bottom: 40px;\r\n  }\r\n\r\n  .testimonios-container {\r\n    margin-bottom: 50px;\r\n    padding-bottom: 40px;\r\n  }\r\n\r\n  .testimonios-container .subsection-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .subsection-subtitle {\r\n    font-size: 1.05rem;\r\n    margin-bottom: 22px;\r\n  }\r\n\r\n  .testimonios-video-wrapper {\r\n    gap: 10px;\r\n  }\r\n\r\n  .testimonio-video-frame {\r\n    width: min(74vw, 330px);\r\n    border-width: 3px;\r\n  }\r\n\r\n  .testimonios-nav {\r\n    width: 38px;\r\n    height: 38px;\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .testimonio-play {\r\n    padding: 10px 16px;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .testimonio-frase {\r\n    margin-top: 14px;\r\n    padding: 12px 14px;\r\n    font-size: 0.95rem;\r\n  }\r\n\r\n  .grid-3 {\r\n    grid-template-columns: 1fr;\r\n    gap: 30px;\r\n  }\r\n\r\n  .equipo-foto {\r\n    width: 120px;\r\n    height: 120px;\r\n  }\r\n\r\n  .equipo-card h4 {\r\n    font-size: 1.2em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
